import {Reducer} from 'redux'
import {ContractsActionTypes, ContractsState} from './types';
import ContractsService from "../../services/ContractsService";
import {Tab} from "../../tabs/Tab";
import {Contract} from "../../models/Contract";
import {TabsService} from "../../tabs/TabsService";

// Type-safe initialState!
const initialState: ContractsState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<ContractsState> = (state = initialState, action) => {
	switch (action.type) {
		case ContractsActionTypes.FETCH_ALL_REQUEST: {
			ContractsService.getAll()
			return { ...state, loading: true }
		}
		case ContractsActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case ContractsActionTypes.FETCH_ONE_REQUEST: {
			ContractsService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case ContractsActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case ContractsActionTypes.SAVE_REQUEST: {
			ContractsService.save(action.payload)
			return { ...state, loading: true }
		}
		case ContractsActionTypes.SAVE_COMPLETED: {
			let newContract = action.payload
			let foundIndex = state.list.findIndex(element => element.id === newContract.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case ContractsActionTypes.DELETE_REQUEST: {
			ContractsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case ContractsActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case ContractsActionTypes.DELETE_MULTIPLE_REQUEST: {
			ContractsService.deleteContracts(action.payload)
			return { ...state, loading: true }
		}
		case ContractsActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as ContractsReducer }
